import { apiFetch } from "../_utils/apiInterceptor.js";

const backendUrl = process.env.REACT_APP_BACKEND_URL;
const BASE_URL = `${backendUrl}/api/v1/products/plans`;

export const get = async ({productId, status = true}) => {
  return await apiFetch(
    `${BASE_URL}/?productId=${productId}&status=${status}`,
    {
      method: "GET"
    }
  );
};
